import { render } from 'react-dom';
import React from 'react';
import PreviouslyViewedProducts from '../../../../../javascript/bcom/pages/pip/pipApp/previousProducts/PreviouslyViewedProducts';

export default function previouslyViewedProducts() {
  render(<PreviouslyViewedProducts />, document.getElementById('gcc-prvprodmount'));
}
